import { CrossInFilledCircle } from "assets/icons";
import { t } from "i18next";
import moment from "moment";

import { DeletedProfileInfoProps } from "./DeletedProfileInfo.types";

import styles from "./DeletedProfileInfo.module.scss";

const DeletedProfileInfo = ({
  deletedAt,
  deletedBy,
  accountRestorationDeadline
}: DeletedProfileInfoProps) => {
  const daysLeftToRestore = Math.ceil(
    moment(accountRestorationDeadline).diff(moment(), "days", true)
  );

  return (
    <div className={styles.deletedProfileInfo}>
      <div className={styles.deletedProfileInfo_topLine}>
        <div className={styles.deletedProfileInfo_label}>
          <CrossInFilledCircle width={18} height={18} fill={"#FFFFFF"} />
          {t("Deleted")}
        </div>

        {deletedAt && (
          <span className={styles.deletedProfileInfo_date}>
            {t("on")} {moment(deletedAt).format("DD/MM/YYYY")}
            {deletedBy ? ` ${t("by")} ${t(deletedBy)}` : ""}
          </span>
        )}
      </div>

      <div className={styles.deletedProfileInfo_bottomLine}>
        {daysLeftToRestore > 0 ? (
          <>
            <span className={styles.boldText}>
              {daysLeftToRestore} {t("days")}
            </span>{" "}
            {t("left to restore")}
          </>
        ) : (
          `${t("account restoration deadline was on")} ${moment(
            accountRestorationDeadline
          ).format("DD/MM/YYYY")}`
        )}
      </div>
    </div>
  );
};

export default DeletedProfileInfo;
